var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsEnum, IsNumber, IsOptional, IsString, IsUUID } from 'class-validator';
import { BodyActivity } from '../enums/body-activity.enum.js';
export class UpdateUserDiagnosis {
    userId;
    bodyWeight;
    bodyHeight;
    bodyActivity;
    patientRisk;
    preExistingConditions;
    allergies;
}
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateUserDiagnosis.prototype, "userId", void 0);
__decorate([
    IsOptional(),
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], UpdateUserDiagnosis.prototype, "bodyWeight", void 0);
__decorate([
    IsOptional(),
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], UpdateUserDiagnosis.prototype, "bodyHeight", void 0);
__decorate([
    IsOptional(),
    IsEnum(BodyActivity),
    Expose(),
    __metadata("design:type", String)
], UpdateUserDiagnosis.prototype, "bodyActivity", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UpdateUserDiagnosis.prototype, "patientRisk", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UpdateUserDiagnosis.prototype, "preExistingConditions", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UpdateUserDiagnosis.prototype, "allergies", void 0);
//# sourceMappingURL=update-user-diagnosis.dto.js.map